import React, { useState, useEffect } from 'react';
import PrimaryButton from "../../components/PrimaryButton";
import SecondaryButton from "../../components/SecondaryButton";

export default function AddKategorije({ kategorija = null, onSuccess = () => {} }) {
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');



    // When kategorija changes (or on mount), fill form for editing
    useEffect(() => {
        if (kategorija) {
            setName(kategorija.name || '');
            setDescription(kategorija.description || '');
        } else {
            setName('');
            setDescription('');
        }
        setMessage('');
    }, [kategorija]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage('');
        if (!name.trim()) {
            setMessage('Naziv kategorije je obavezan.');
            setLoading(false);
            return;
        }
        const apiUrl = process.env.REACT_APP_WORDPRESS_URL;

        try {
            const token = localStorage.getItem('wp_jwt');
            const isEdit = Boolean(kategorija && kategorija.term_id);

            const url = `${apiUrl}/wp-json/biznis/v1/kategorije`;

            const method = 'POST';
            const formData = new FormData();
            formData.append('name', name.trim());
            formData.append('description', description.trim());
            if (isEdit)
                formData.append('id', kategorija.term_id)

            const response = await fetch(url, {
                method: method,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                body: formData,
            });


            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || (isEdit ? 'Greška prilikom ažuriranja kategorije' : 'Greška prilikom dodavanja kategorije'));
            }

            setMessage(isEdit ? 'Kategorija uspješno ažurirana!' : 'Kategorija uspješno dodana!');
            if (!isEdit) {
                setName('');
                setDescription('');
            }
            onSuccess(data); // callback to parent, pass updated/created category
        } catch (error) {
            console.error(error);
            setMessage(error.message || 'Došlo je do greške.');
        } finally {
            setLoading(false);
        }
    };
    const handleDelete = async () => {
        if (!kategorija || !kategorija.term_id) {
            setMessage('Kategorija nije odabrana za brisanje.');
            return;
        }

        const confirmDelete = window.confirm(`Jeste li sigurni da želite obrisati kategoriju "${kategorija.name}"?`);
        if (!confirmDelete) return;

        setLoading(true);
        setMessage('');
        const apiUrl = process.env.REACT_APP_WORDPRESS_URL;

        try {
            const token = localStorage.getItem('wp_jwt');
            const url = `${apiUrl}/wp-json/biznis/v1/kategorije/${kategorija.term_id}`;

            const response = await fetch(url, {
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || 'Greška prilikom brisanja kategorije');
            }

            setMessage('Kategorija uspješno obrisana!');
            onSuccess(); // Refresh or notify parent to remove the category from the list
        } catch (error) {
            console.error(error);
            setMessage(error.message || 'Došlo je do greške.');
        } finally {
            setLoading(false);
        }
    };


    return (
        <div className="p-4 bg-white rounded-xl shadow-md max-w-md mx-auto">
            <h2 className="text-xl font-bold mb-4">{kategorija ? 'Uredi Kategoriju' : 'Dodaj Kategoriju'}</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700">Naziv kategorije</label>
                    <input
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                        className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700">Opis (opcionalno)</label>
                    <textarea
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        rows={3}
                        className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                    ></textarea>
                </div>
                <div className="flex justify-between">
                    <SecondaryButton
                        type="button"
                        disabled={loading || !kategorija}
                        onClick={handleDelete}
                    >
                        {loading ? 'Brisanje...' : 'Obriši'}
                    </SecondaryButton>
                    <PrimaryButton
                        type="submit"
                        disabled={loading}
                        className="bg-blue-900 text-white px-4 py-2 rounded-md hover:bg-blue-700"
                    >
                        {loading ? (kategorija ? 'Ažuriranje...' : 'Dodavanje...') : (kategorija ? 'Ažuriraj' : 'Dodaj')}
                    </PrimaryButton>
                </div>

            </form>
            {message && <p className="mt-4 text-sm text-green-600">{message}</p>}
        </div>
    );
}
